import { useTranslation } from "react-i18next";
import { PRESET_NAMES, PRESETS, type PresetName, presetToCssVars, DENSITY_RULES } from "@re/shared";

/** Read-only gallery: renders all 5 presets side-by-side as static cards (no site-wide switching). */
export function PresetGallery() {
  return (
    <ul className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
      {PRESET_NAMES.map((name) => (
        <li key={name}>
          <PresetCard name={name} />
        </li>
      ))}
    </ul>
  );
}

function PresetCard({ name }: { name: PresetName }) {
  const { t } = useTranslation();
  const p = PRESETS[name];
  const vars = presetToCssVars(name);
  const density = DENSITY_RULES[p.density];
  return (
    <div
      className="rounded-lg border-2 p-4 transition"
      style={{
        ...vars,
        borderColor: "color-mix(in oklab, currentColor 10%, transparent)",
        background: p.bg,
        color: p.text,
        fontFamily: `"${p.body_font}", system-ui, sans-serif`,
      }}
    >
      <div className="flex items-baseline justify-between">
        <span className="text-xs font-mono opacity-60">{name}</span>
        <span className="text-xs" style={{ color: p.accent1 }}>{p.density}</span>
      </div>
      <h3 className="mt-2 text-2xl" style={{ fontFamily: `"${p.heading_font}", sans-serif`, fontWeight: p.heading_weight }}>
        {t("viz.sampleHeadlineLead")} <span style={{ color: p.accent1 }}>+23%</span>
      </h3>
      <p className="mt-1 text-sm opacity-70">assertion-evidence headline · 5 categorical colors</p>
      <div className="mt-3 flex gap-1.5">
        {p.palette.slice(0, 5).map((c, i) => (
          <span key={i} className="h-5 flex-1 rounded-sm" style={{ background: c }} title={c} />
        ))}
      </div>
      <div className="mt-3 grid grid-cols-3 gap-2 text-xs opacity-70">
        <div>bg <span className="font-mono">{p.bg}</span></div>
        <div>a1 <span className="font-mono">{p.accent1}</span></div>
        <div>a2 <span className="font-mono">{p.accent2}</span></div>
      </div>
      <p className="mt-3 text-xs opacity-50">
        font: {p.heading_font} / {p.body_font} · padding {density.padding_top}/{density.padding_side}
      </p>
      <p className="mt-2 text-xs opacity-70">{p.use_when}</p>
    </div>
  );
}
